import { generateMFCAgainCTA } from '../../../utils/puAppBridge'
import { getBottomPadding, getTopPadding } from '../../../utils/sessionStorage'
import { PrimaryButton } from '../../../components/execution/PrimaryButton'
import RenderHTML from '../../../components/ui-components/RenderHTML'
import ThreeLineLoading from '../../../components/ui-components/loading/ThreeLineLoading'
import { MFCRedirectionErrorPage } from './MFCRedirectionErrorPage'
import { useMFCRedirection } from '../hooks/useMFCRedirection'

export const TickSymbol = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <path d="M10.5 2L4.5 9L1.5 6.66667" stroke="#8E9393" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

export default function MFCRedirectionQRPage() {
    const { error, isPending, isSuccess, onTryAgain, onGoToPortfolio, onContinueClick } = useMFCRedirection({
        componentTag: 'MFCRedirectionQRPage',
        uploadOnSuccess: false
    })

    const onGenerateAgain = () => {
        generateMFCAgainCTA()
    }

    if (error) {
        return (
            <MFCRedirectionErrorPage
                statusCode={error?.code ?? 'unknown'}
                message={error?.message ?? 'Please try again.'}
                onTryAgain={onTryAgain}
                onGoToPortfolio={onGoToPortfolio}
            />
        )
    }

    if (isPending) return <ThreeLineLoading />
    if (isSuccess) {
        return (
            <div className='h-screen bg-white flex flex-col min-h-0'>
                <div
                    className='px-6 flex items-start justify-between'
                    style={{ paddingTop: `calc(${getTopPadding()}px + 8px)` }}
                >
                    <div>
                        <p className='text-[16px] font-[500] text-[#1470CC]'>QR captured successfully</p>
                        <h1 className='mt-1 text-[22px] font-[500] leading-[130%] text-[#232323]'>
                            Continue to track your mutual fund portfolio
                        </h1>
                    </div>
                </div>
                <div className='flex-1 min-h-0 overflow-y-auto no-scrollbar px-6 pt-6 flex flex-col'>
                    <div className='flex-1 min-h-[233px] w-full rounded-3xl border border-dashed border-[#E2E8F0] 
                    flex flex-col items-center justify-center py-10 overflow-y-auto no-scrollbar'>
                        <div className='relative max-w-[160px] max-h-[160px]'>
                            <img src={"/images/mfc-qr.svg"} alt="MFC QR" className='w-full h-full object-contain' />
                        </div>
                        <p className='pt-5 text-base text-[#111827]'>QR captured successfully</p>
                    </div>
                    <div className='pt-4 pb-16 space-y-2'>
                        <div className='flex items-center justify-center gap-2 pr-1'>
                            <RenderHTML innerHTMLText={TickSymbol} />
                            <span className='text-[13px] font-[400] text-[#8E9393]'>We are SEBI registered RIA : INA000019798</span>
                        </div>
                        <div className='flex items-center justify-center gap-2 pr-1'>
                            <RenderHTML innerHTMLText={TickSymbol} />
                            <span className='text-[13px] font-[400] text-[#8E9393]'>Your data is encrypted and 100% secure</span>
                        </div>
                    </div>
                </div>
                <div style={{ paddingBottom: `${getBottomPadding() + 8}px` }} className='mt-auto flex flex-col px-6 pt-6'>
                    <PrimaryButton label="Continue" onClick={onContinueClick} primaryButtonClassName='!h-[56px] !text-[16px] !font-[500]' />
                    <div className='pt-4 text-center text-[14px] font-[400] text-[#6A6E6E]'>
                        <span>Have not selected all AMCs? </span>
                        <span onClick={onGenerateAgain} className='underline cursor-pointer'>Generate again</span>
                    </div>
                </div>
            </div>
        )
    }
    return <ThreeLineLoading />
}
